import HasPermission from '../../../components/HasPermission';
import { useIsAskCrossSell } from './useIsAskCrossSell';

export const ProvisioningVOCWrapper = ({
  children,
}: {
  children: JSX.Element;
}): null | JSX.Element =>
  useIsAskCrossSell() === true ? (
    <HasPermission rolesAccepted={['admin', 'dxa_voc_manual_provisioning']}>
      {children}
    </HasPermission>
  ) : null;
